const translations = {
    fileUploads: 'File Uploads',
    flightReportError: 'Error adding flight report',
    flightReportUpload: 'Flight Report Upload',
    reportingPeriod: 'Reporting Period'
};

export default translations;
